import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"

interface Props {
  imageUrl?: string
  name?: string
  isThumbnail?: boolean
}

export const PostAuthor: React.FC<Props> = ({
  imageUrl,
  name,
  isThumbnail,
}) => {
  return (
    <StyledLink to={`/author/${name}/all`}>
      <AuthorImage imageUrl={imageUrl} />
      <div>
        <AuthorName isThumbnail={isThumbnail}>{name}</AuthorName>
      </div>
    </StyledLink>
  )
}

const AuthorImage = styled.div<{ imageUrl?: string }>`
  height: 36px;
  width: 36px;
  margin-right: 10px;
  border-radius: 18px;
  overflow: hidden;
  background-color: #ececec;
  background-size: cover;
  background-image: ${({ imageUrl }) =>
    imageUrl ? `url(${imageUrl})` : "none"};
`

const AuthorName = styled.div<{ isThumbnail?: boolean }>`
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 4px;
  opacity: ${({ isThumbnail }) => (isThumbnail ? 1 : 0.8)};
  color: ${({ isThumbnail }) => (isThumbnail ? "white" : "black")};
`

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
`
